export default [
  {
    name: "dashboard",
    display: "Dashboard",
  },
  {
    name: "forms",
    display: "My Forms",
  },
  {
    name: "employees",
    display: "Employees",
  },
  {
    name: "employee-requests",
    display: "Employee Requests",
    employee_requests: true,
  },
  {
    name: "visitors",
    display: "Visitors",
  },
  {
    name: "reminderManagement",
    display: "Reminder Management",
  },
  {
    name: "check-in",
    display: "Check-In",
  },
  {
    name: "reports",
    display: "Reports",
  },
  // {
  //   name: "kiosks",
  //   display: "Kiosk Links",
  //   section: "Kiosks",
  // },
  {
    name: "profile",
    display: "Company Profile",
    section: "Settings",
  },
  {
    name: "managers",
    display: "Managers",
    section: "Settings",
  },
  {
    name: "locations",
    display: "Locations",
    section: "Settings",
  },
  {
    name: "departments",
    display: "Departments",
    section: "Settings",
  },
  {
    name: "subscription",
    display: "Subscription",
    section: "Settings",
  },
  {
    name: "ads",
    display: "Kiosk Content",
    section: "Settings",
  },
  {
    name: "terms",
    display: "Terms",
    section: "Content",
  },
  {
    name: "privacy",
    display: "Privacy",
    section: "Content",
  },
  {
    name: "post_failure_message",
    display: "Post Failure Message",
    section: "Content",
  },
  {
    name: "post_neutral_message",
    display: "Post Neutral Message",
    section: "Content",
  },
  {
    name: "post_success_message",
    display: "Post Success Message",
    section: "Content",
  },
  {
    name: "support",
    display: "Open Support Ticket",
    section: "Support",
  },
  {
    name: "videos",
    display: "Video Tutorials",
    section: "Support",
  },
];
